<template>
  <div class="rows is-full-height is-gapless contact-edit">
    <div class="row" style="overflow: auto;">
      <div style="width: 100%;">
        <div class="layout-padding">
          <div class="list form"
          style="position: relative;">
            <v-modal 
            v-model="bookmark_modal_open"
            class="is-half">
              <div class="rows is-full-height is-gapless">
                <div class="row is-narrow">
                  <nav class="navbar primary"
                  style="padding: 10px;">
                    <span>Carnet</span>
                  </nav>
                </div>
                <div class="row is-full-height"
                style="padding: 10px; overflow: auto;">
                  <div style="width: 100%;">
                    <div class="row">
                      <div
                      v-if="contactData.base.data.in_univers === '1'"
                      style="width: 100%;">
                        Retirer du carnet ?
                      </div>
                      <div
                      v-else
                      style="width: 100%;">
                        Ajouter au carnet ?
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row is-narrow">
                  <nav class="navbar primary">
                      <div
                      class="button primary full-width"
                      style="border: 0;"
                      @click="submitBookmark">OK</div>
                  </nav>
                </div>
              </div>
            </v-modal>

            <div class="item">
              <div class="columns is-mobile is-gapless">
                <div class="column is-6">
                  <v-checkbox
                  class="is_external_checkbox"
                  label="Externe?"
                  style="float: left; padding-left: 1.6rem;"
                  v-model="contactData.base.data.is_external"
                  @click.stop.prevent
                  @input.once="set_push('base')"
                  ></v-checkbox>
                </div>
                <div
                v-if="univers >1"
                @click="openBookmarkModal"
                :class="{
                  active: contactData.base.data.in_univers === '1'
                }"
                class="bookmark-tag-btn column is-6">
                  <i class="bookmark"
                  style="float: right; padding-right: 1rem;"></i>
                </div>
              </div>
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <v-select
                  class="floating-label full-width"
                  placeholder="Type"
                  v-model="contactData.base.data.type"
                  :opened.sync="contactData.base.type_opened"
                  :items="type_items"
                  valueKey="icon"
                  @input.once="set_push('base')">
                    <template slot="display" 
                    slot-scope="d">
                      <div class="btn" 
                      style="margin: auto;"
                      v-html="d.item.icon + '<i class=\'caret-down\'>'"></div>
                    </template>
                  </v-select>
                </div>
                <div class="item-content column">
                  <div class="columns is-gapless">
                    <div class="column">
                      <v-input class="floating-label full-width"
                      @input.once="set_push('base')"
                      v-model="contactData.base.data.lastname"
                      placeholder="Nom">
                      </v-input>
                    </div>
                    <div class="column">
                      <v-input class="floating-label full-width"
                      @input.once="set_push('base')"
                      v-model="contactData.base.data.firstname"
                      :placeholder="(contactData.base.data.type == 1) ? 'Prénom': 'Acronyme'">
                      </v-input>
                    </div>

                    <div 
                    v-if="contactData.base.data.type == 1"
                    class="column is-2">
                      <v-select
                      class="floating-label full-width"
                      placeholder="Civilité"
                      :opened.sync="contactData.base.subtype_opened"
                      v-model="contactData.base.data.subtype"
                      :items="contact_attr"
                      @input.once="set_push('base')">
                      </v-select>
                    </div>

                    <div 
                    v-else
                    class="column is-2">
                      <v-select
                      class="floating-label full-width"
                      placeholder="Type"
                      :opened.sync="contactData.base.subtype_opened"
                      v-model="contactData.base.data.subtype"
                      :items="organization_attr"
                      @input.once="set_push(contactData.base)">
                      </v-select>

                    </div>
                  </div>
                </div>
                <div class="item-icon column is-1 del">
                  <div class="btn">
                    <i></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="item">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <div class="btn"
                  @click="addField('emails')">
                    <i class="envelope"></i>
                    <i class="plus"></i>
                  </div>
                </div>
                <div class="column">
                  <div 
                  v-for="(email, index) in contactData.emails"
                  :key="email.data.rel_id"
                  class="columns is-gapless is-multiline">
                    <div class="item-content column">
                      <div class="columns is-gapless">
                        <div class="column">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('emails', index)"
                          v-model="email.data.value"
                          placeholder="Email">
                          </v-input>
                        </div>
                        <div class="column is-2">
                          <v-select
                          class="floating-label full-width"
                          placeholder="Libellé"
                          :opened.sync="email.type_opened"
                          v-model="email.data.rel_type_id"
                          :items="email_attr"
                          @input.once="set_push('emails', index)">
                          <!-- :value="email.rel_type_val" -->
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del">
                      <v-radio
                      v-model="primary.emails"
                      :val="email.data.rel_id"
                      @input="primary_change($event, 'emails')"
                      ></v-radio>
                      <div class="btn del-btn"
                      v-if="index > 0 || contactData.emails.length > 0"
                      @click="delField('emails', index)">
                        <i class="del"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="item">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <div class="btn"
                  @click="addField('phones')">
                    <i class="phone"></i>
                    <i class="plus"></i>
                  </div>
                </div>
                <div class="column">
                  <div 
                  v-for="(phone, index) in contactData.phones"
                  :key="phone.data.rel_id"
                  class="columns is-gapless">
                    <div class="item-content column">
                      <div class="columns is-gapless">
                        <div class="column">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('phones', index)"
                          v-model="phone.data.value"
                          placeholder="Numéro">
                          </v-input>
                        </div>
                        <div class="column is-2">
                          <v-select
                          class="floating-label full-width"
                          placeholder="Libellé"
                          :opened.sync="phone.type_opened"
                          v-model="phone.data.rel_type_id"
                          :items="phone_attr"
                          @input.once="set_push('phones', index)">
                          </v-select>
                          <!-- :value="phone.rel_type_val" -->
                        </div>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del">
                      <v-radio
                      v-model="primary.phones"
                      :val="phone.data.rel_id"
                      @input="primary_change($event, 'phones')"
                      ></v-radio>
                      <div class="btn del-btn"
                      v-if="index > 0 || contactData.phones.length > 0"
                      @click="delField('phones', index)">
                        <i class="del"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="item">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <div class="btn"
                  @click="addField('addresses')">
                    <i class="home3"></i>
                    <i class="plus"></i>
                  </div>
                </div>
                <div class="column">
                  <div 
                  v-for="(address, index) in contactData.addresses"
                  :key="address.data.rel_id"
                  class="columns is-gapless">
                    <div class="item-content column">
                      <div class="columns is-gapless">
                        <div class="column">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('addresses', index)"
                          v-model="address.data.street"
                          placeholder="Rue">
                          </v-input>
                        </div>
                        <div class="column is-2">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('addresses', index)"
                          v-model="address.data.city"
                          placeholder="Ville">
                          </v-input>
                        </div>
                        <div class="column is-2">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('addresses', index)"
                          v-model="address.data.zip"
                          placeholder="Code postal">
                          </v-input>
                        </div>
                        <div class="column is-2">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('addresses', index)"
                          v-model="address.data.extended"
                          placeholder="Cedex">
                          </v-input>
                        </div>
                        <div class="column is-2">
                          <v-select
                          class="floating-label full-width"
                          placeholder="Libellé"
                          :opened.sync="address.type_opened"
                          v-model="address.data.rel_type_id"
                          :items="address_attr"
                          @input.once="set_push('addresses', index)">
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del">
                      <v-radio
                      v-model="primary.addresses"
                      :val="address.data.rel_id"
                      @input="primary_change($event, 'addresses')"
                      ></v-radio>
                      <div class="btn del-btn"
                      v-if="index > 0 || contactData.addresses.length > 0"
                      @click="delField('addresses', index)">
                        <i class="del"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="contactData.base.data.type == 1"
            class="item">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <div class="btn"
                  @click="addField('organizations')">
                    <i class="institution"></i>
                    <i class="plus"></i>
                  </div>
                </div>
                <div class="column">
                  <div 
                  v-for="(organization, index) in contactData.organizations"
                  :key="index"
                  class="columns is-gapless">
                    <div class="item-content column">
                      <div class="columns is-gapless">
                        <div class="column is-2">
                          <v-select
                          class="floating-label full-width"
                          placeholder="Type"
                          :opened.sync="organization.type_opened"
                          v-model="organization.type_id"
                          :items="organization_attr"
                          @input.once="set_push('organizations', index)"
                          @input="onOrgTypeSelect($event, index)"
                          >
                          </v-select>
                        </div>
                        <div class="column">
                          <v-form-dropdown search fluid
                          placeholder="Organisation"
                          :opened.sync="organization.opened"
                          class="input-control no-overflow full-width"
                          v-model="organization.data.value"
                          :filter="organization.input"
                          :display="organization.display"
                          :items="organization.items"
                          :min_letters="0"
                          :autoOpen="false"
                          @click.stop.prevent
                          @filter="onOrgFilter($event, index)"
                          @input.once="set_push('organizations', index)"
                          @input="function (item_id, item) {
                            onOrgSelect(item_id, item, index)
                          }">
                          </v-form-dropdown>
                        </div>
                        <div class="column is-2">
                          <v-select
                          class="floating-label full-width"
                          placeholder="Rôle"
                          :opened.sync="organization.role_opened"
                          v-model="organization.data.rel_type_id"
                          :items="get_attributes(organization.type_id)"
                          @input.once="set_push('organizations', index)"
                          >
                          </v-select>
                        </div>
                        <div class="column is-2"
                        v-if="services[organization.data.value]">
                          <v-select
                          class="floating-label full-width"
                          :opened.sync="organization.service_opened"
                          placeholder="Service"
                          displayKey="value"
                          v-model="organization.data.service_id"
                          :items="services[organization.data.value]"
                          @input.once="set_push('organizations', index)"
                          >
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del">
                      <v-radio
                      v-model="primary.organizations"
                      :val="organization.data.rel_id"
                      @input="primary_change($event, 'organizations')"
                      ></v-radio>
                      <div class="btn del-btn"
                      v-if="index > 0 || contactData.organizations.length > 0"
                      @click="delField('organizations', index)">
                        <i class="del"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="item">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <div class="btn"
                  @click="addField('groups')">
                    <i class="tags"></i>
                    <i class="plus"></i>
                  </div>
                </div>
                <div class="column">
                  <div 
                  v-for="(group, index) in contactData.groups"
                  :key="index"
                  class="columns is-gapless">
                    <div class="item-content column">
                      <div class="columns is-gapless">
                        <div class="column is-2">
                          <v-select
                          class="floating-label full-width"
                          placeholder="Type"
                          v-model="group.type_id"
                          :opened.sync="group.type_opened"
                          :items="group_attr"
                          @input.once="set_push('groups', index)"
                          @input="onGroupTypeSelect($event, index)">
                          </v-select>
                        </div>
                        <div class="column">
                          <v-form-dropdown
                          class="input-control no-overflow full-width"
                          placeholder="Groupe"
                          :opened.sync="group.opened"
                          v-model="group.data.value"
                          :filter="group.input"
                          :display="group.display"
                          :items="group.items"
                          :min_letters="0"
                          :autoOpen="false"
                          @click.stop.prevent
                          @filter="onGroupFilter($event, index)"
                          @input.once="set_push('groups', index)"
                          @input="function (item_id, item) {
                            onGroupSelect(item_id, item, index)
                          }">
                          </v-form-dropdown>
                        </div>
                        <div 
                          v-if="group.type_id==35"
                          class="column is-2">
                          <v-select
                          class="floating-label full-width"
                          placeholder="Rôle"
                          v-model="group.data.rel_type_id"
                          :opened.sync="group.subtype_opened"
                          :items="comission_attr"
                          @input.once="set_push('groups', index)"
                          @input="onGroupSubtypeSelect($event, index, group)">
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del">
                      <v-radio
                      v-model="primary.groups"
                      :val="group.data.rel_id"
                      @input="primary_change($event, 'groups')"
                      ></v-radio>
                      <div class="btn del-btn"
                      v-if="index > 0 || contactData.groups.length > 0"
                      @click="delField('groups', index)">
                        <i class="del"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="item">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <div class="btn"
                  @click="addField('websites')">
                    <i class="earth"></i>
                    <i class="plus"></i>
                  </div>
                </div>
                <div class="column">
                  <div 
                  v-for="(website, index) in contactData.websites"
                  :key="website.data.rel_id"
                  class="columns is-gapless">
                    <div class="item-content column">
                      <div class="columns is-gapless">
                        <div class="column">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('websites', index)"
                          v-model="website.data.value"
                          placeholder="Site web">
                          </v-input>
                        </div>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del">
                      <v-radio
                      v-model="primary.websites"
                      :val="website.data.rel_id"
                      @input="primary_change($event, 'websites')"
                      ></v-radio>
                      <div class="btn del-btn"
                      v-if="index > 0 || contactData.websites.length > 0"
                      @click="delField('websites', index)">
                        <i class="del"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="item"
             v-if="contactData.base.data.type == 2">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <div class="btn"
                  @click="addField('services')">
                    <i class="sitemap"></i>
                    <i class="plus"></i>
                  </div>
                </div>
                <div class="column">
                  <div 
                  v-for="(service, index) in services"
                  :key="service.data.id"
                  class="columns is-gapless">
                    <div class="item-content column">
                      <div class="columns is-gapless">
                        <div class="column">
                          <v-input class="floating-label full-width"
                          @input.once="set_push('services', index)"
                          v-model="service.data.value"
                          placeholder="Service">
                          </v-input>
                        </div>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del">
                      <div class="btn"
                      v-if="index > 0 || contactData.services.length > 0"
                      @click="delField('services', index)">
                        <i class="del"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="item">
              <div class="columns is-mobile is-gapless">
                <div class="item-icon column is-1">
                  <i class="comment2"></i>
                </div>
                <div class="item-content column">
                  <div class="columns is-gapless">
                    <div class="column">
                      <div class="textfield floating-label full-width">
                        <textarea 
                        v-model="contactData.notes.data.value"
                        @input.once="set_push('notes')"
                        required class="full-width"></textarea>
                        <label>Notes</label>
                      </div>
                    </div>
                    <div class="item-icon column is-1 del"
                    style="padding-right: 0 !important;">
                      <div class="btn">
                        <i></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <notifications group="edit_fail" :max="3" position="top center"/>
    <div class="row is-narrow">
      <nav class="navbar primary justify-center">
        <div
        class="button primary full-width"
        :disabled="modified.length < 1"
        @click.stop.prevent="submitContact">Sauvegarder</div>
      </nav>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import Edit_meta from './Edit_meta.js'
import typeahead from '../components/utils/typeahead.js'

export default {
  data: () => ({
    univers: global.univers,
    bookmark_modal_open: false,
    contact_id: 0,
    type_value: '',
    subtype_value: '',
    contactData: Edit_meta.full_blank_state(),
    modified: [],
    services_modified: false,
    type_items: [
      {
        id: '1',
        n: '<i class="person"></i> Personne',
        icon: '<i class="person"></i>'
      },
      {
        id: '2',
        n: '<i class="institution"></i> Organisation',
        icon: '<i class="institution"></i>'
      }
    ],
    orgs_index_types: window.orgs_index.types,
    primary: {
      'emails': 0,
      'addresses': 0,
      'phones': 0,
      'websites': 0,
      'groups': 0,
      'organizations': 0,
    }
  }),

  computed: {
    bookmark_action: {
      get () {
        return this.$store.getters.listUniversSingleAction
      },
      set (value) {
        this.$store.commit('ListSetUniversSingleAction', value)
      }
    },
    // type: function () {
    //   return this.$store.state.type
    // },

    services: function () {
      if (Number(this.contactData.base.data.type) === 2) {
        if (typeof this.$store.state.services[this.contact_id] !== 'undefined' &&
          this.$store.state.services[this.contact_id].length > 0) {
          let res = []
          let r
          let services = this.$store.state.services[this.contact_id]
          services.forEach(function (service) {
            r = Edit_meta.blank_states['services']()
            // console.log(r)
            r.data.id = service.id
            r.data.value = service.value
            // r.data.data_type_id = 10
            res.push(r)
          })
          return res
        }
        return [Edit_meta.blank_states['services']()]
      }
      else {
        return this.$store.state.services
      }
    },
    // get_attributes: function (type) {
    //   return this.$store.getters.listGetAttributes(type)
    // },
    // email_attr_label: 'listAttributesEmailLabel',
    // phone_attr_label: 'listAttributesPhoneLabel',
    // address_attr_label: 'listAttributesAddressLabel',
    ...Vuex.mapGetters({
      email_attr: 'listAttributesEmail',
      phone_attr: 'listAttributesPhone',
      address_attr: 'listAttributesAddress',
      group_attr: 'listAttributesGroup',
      organization_attr: 'listAttributesOrganization',
      contact_attr: 'listAttributesContact',
      comission_attr: 'listAttributesCommission',
      get_attributes: 'listGetAttributes'
    })
  },
  methods: {
    ...Vuex.mapActions({
      submitSingleUnivers: 'listSubmitSingleUnivers'
    }),

    primary_change: function (input, k) {
      var vm = this
      var items = this.contactData[k]

      items.forEach(function(item){
        if(item.data.rel_id == input) {
          item.data.is_primary = 1
        }
        else {
          item.data.is_primary = 0
        }

        item.data.action = 'set'
        vm.modified.unshift(item.data)
      })

    },

    // set_push: function (item, val, index) {
    set_push: function (key, index) {
      // unsift for this one so it's always first, dirty trick
      var vm = this
      let item

      if(key === 'base' || key === 'notes'){
        item = vm.contactData[key]
      }
      else {
        item = vm.contactData[key][index]
      }

      // console.log('item', item)

      if (!item.set_pushed) {
        setTimeout(function () {
          item.set_pushed = true
          item.data.action = 'set'
          vm.modified.unshift(item.data)

          if (item.data.data_type_id === 10) {
            vm.services_modified = true
          }
        })
      }
    },
    openBookmarkModal: function () {
      this.modal_univers_single_action = null
      var action = ''

      if (this.contactData.base.data.in_univers === '1') {
        action = 'del'
      }
      else if (this.contactData.base.data.in_univers === '0') {
        action = 'add'
      }

      var data = {
        action: action,
        id: this.contact_id
      }
      // console.log(this.contactData.base.data)

      this.bookmark_action = data
      this.bookmark_modal_open = true
    },

    submitBookmark: function () {
      this.submitSingleUnivers()
      .then((response) => {

        // console.log('bookmark_action', this.bookmark_action)
        if(this.bookmark_action.action === 'add') {
          this.contactData.base.data.in_univers = '1'
        }
        else {
          this.contactData.base.data.in_univers = '0'
        }
        // console.log('in_univers', this.contactData.base.data.in_univers)

        this.bookmark_modal_open = false
      }, (response) => {
        // error callback
      })
    },
    // set_push_service: function (item) {
    //   var vm = this
    //   setTimeout(function () {
    //     item.data.action = 'set'
    //     vm.modified.unshift(item.data)
    //     if (item.data.data_type_id === 10) {
    //       vm.services_modified = true
    //     }
    //   })
    // },
    del_push: function (item) {
      var vm = this
      if (!item.set_pushed) {
        setTimeout(function () {
          item.set_pushed = true
          if (Number(item.data.rel_id) > 0 ||
            item.data.data_type_id === 10) {
            // if new item, no need to push
            vm.modified.push(item.data)
            // console.log(item)
            if (item.data.data_type_id === 10) {
              vm.services_modified = true
            }
          }
        })
      }
      item.data.action = 'del'
    },
    // get_organization_roles: function (type) {
    //   if (type > 0 &&
    //   global.tree_index[type] &&
    //   global.tree_index[type].children &&
    //   global.tree_index[type].children[0] &&
    //   global.tree_index[type].children[0].children
    //   ) {
    //     return global.tree_index[type].children[0].children
    //   }
    //   return []
    // },
    get_organization_items: function (type, input) {
      let filter = null

      if (input === '') {
        if (Number(type) === 0) {
          return window.orgs_index.list
        }

        if (window.orgs_index.types[type]) {
          return typeahead.get_display(
            window.orgs_index.types[type],
            window.orgs_index
          )
        }

        return []
      }

      if (type > 0) {
        filter = function (item) {
          return item.type === type
        }
      }

      return typeahead.filter_list(
        input,
        window.orgs_index,
        null,
        filter
      )
    },
    get_group_items: function (type, input) {
      let filter = null

      if (input === '') {
        if (Number(type) === 0) {
          return window.groups_index.list
        }

        if (window.groups_index.types[type]) {
          return typeahead.get_display(
            window.groups_index.types[type],
            window.groups_index
          )
        }

        return []
      }

      if (type > 0) {
        filter = function (item) {
          return item.type === type
        }
      }

      return typeahead.filter_list(
        input,
        window.groups_index,
        null,
        filter
      )
    },
    onGroupTypeSelect: function (item_id, index) {
      let state = this.contactData.groups[index]
      // state.type_val = item.n
      state.type_id = Number(item_id)
      state.data.value = 0
      state.display = ''
      state.opened = true
      state.items = this.get_group_items(
        state.type_id,
        state.input
      )
    },
    onGroupSubtypeSelect: function (item_id, index, group) {
      let state = this.contactData.groups[index]
      group.rel_type_id = Number(item_id)


      console.log('onGroupSubtypeSelect', group)
      // let state = this.contactData.groups[index]

      // state.type_id = Number(item_id)
      // state.data.value = 0
      // state.display = ''
      // state.opened = true
      // state.items = this.get_group_items(
      //   state.type_id,
      //   state.input
      // )
    },
    onOrgTypeSelect: function (item_id, index) {
      let state = this.contactData.organizations[index]
      // state.type_val = item.n
      state.type_id = Number(item_id)
      state.data.value = 0
      state.display = ''
      state.opened = true
      state.data.rel_type_id = 0
      // state.rel_type_val = ''
      state.items = this.get_organization_items(
        state.type_id,
        state.input
      )
    },
    onOrgRoleSelect: function (item_id, index) {
      let state = this.contactData.organizations[index]
      // state.rel_type_val = item.n
      state.data.rel_type_id = item_id
    },
    onGroupSelect: function (item_id, item, index) {
      let state = this.contactData.groups[index]
      state.data.value = item.id
      state.display = item.n
      state.type_id = item.type
    },
    onOrgSelect: function (item_id, item, index) {
      let state = this.contactData.organizations[index]
      state.data.value = item.id
      state.display = item.n
      state.rel_type_id = 0

      state.type_id = item.type
      state.roles = this.get_attributes(state.type_id)
    },
    onOrgFilter: function (input, index) {
      let state = this.contactData.organizations[index]
      state.input = input
      state.items = this.get_organization_items(
        state.type_id,
        state.input
      )
    },
    onGroupFilter: function (input, index) {
      let state = this.contactData.groups[index]
      state.input = input
      state.items = this.get_group_items(
        state.type_id,
        state.input
      )
    },
    addField: function (k) {
      let new_field = Edit_meta.blank_states[k]()
      new_field.data.is_primary = 0
      console.log('new_field', JSON.stringify(new_field))
      if (k === 'services') {
        // new_field.data
        this.$store.commit('AddService', {
          org_id: this.contact_id,
          data: new_field.data
        })
      }
      else {
        this.contactData[k].push(new_field)
      }
    },
    delField: function (k, index) {
      if (k === 'services') {
        let service_data = this.$store.state.services[this.contact_id][index]
        service_data.data_type_id = 10
        this.del_push({
          data: service_data
        })
        this.$store.commit('DelService', {
          org_id: this.contact_id,
          index: index
        })
      }
      else {
        let fields = this.contactData[k]
        let deleted_field

        if (fields.length > 1) {
          deleted_field = fields.splice(index, 1)
        }
        else {
          let blank_field = Edit_meta.blank_states[k]()
          deleted_field = fields.splice(index, 1, blank_field)
        }
        this.del_push(deleted_field[0])
      }
    },
    submitContact: function () {
      // check data here
      let vm = this
      let action = (vm.contact_id > 0) ? 'set' : 'new'
      // let action = (vm.contact_id > 0) ? 'set' : 'new'
      // // cozette.jean83@orange.fr
      console.log('modified', vm.modified)

      let params = {
        cid: vm.contact_id,
        data: vm.modified,
        token: global.token
      }

      console.log("params", params)

      // return false

      vm.$http.post(
        global.app_path + 'main.php?action=' + action,
        params)
      .then(function (response) {

        var data = response.body

        // console.log('ok', response)
        // return false

        if(data.success) {
          if (vm.services_modified) {
            vm.$store.dispatch('get_services')
            .then(function () {
              vm.$router.push('/gestion/' + vm.$route.params.type)
            })
          }
          else {
            vm.$router.push('/gestion/' + vm.$route.params.type)
          }
        }
        else {
          data.errors.forEach(function(error){

            var text = "Erreur: l'adresse "+error.email+" est déjà utilisée par <a target='_blank' href='#/gestion/contact/edit/"+error.contact_id+"'>un autre contact</a>"

            vm.$notify({
              group: 'edit_fail',
              type: 'error',
              position: 'top center',
              duration: 10000,
              'animation-type': 'velocity',
              text: text
            })
          })
        }
        
      },
      function (response) {
        console.log('error', response)

        
        
        this.$notify({
          group: 'edit_fail',
          type: 'error',
          position: 'top center',
          duration: 10000,
          'animation-type': 'velocity',
          text: 'Erreur inconnue'
        })

        
      })
    }
  },

  mounted () {
    let vm = this
    if (typeof this.$route.params.contact_id !== 'undefined') {
      this.contact_id = this.$route.params.contact_id
    }

    if (this.$route.path.indexOf('/contact') < 0) {
      this.type = 'org'
      this.type_id = 2
    }
    else {
      this.type = 'contact'
      this.type_id = 1
    }

    if (this.contact_id > 0) {
      this.$http.post(
        global.app_path + 'main.php?action=contact_data', {
          cid: this.contact_id,
          type_id: this.type_id,
          token: global.token
        })
        .then((response) => {
          var body = response.body
          let v
          let state
          for (let k in body.data) {
            v = body.data[k]
            switch (k) {
              case 'base':
                state = Edit_meta.blank_states[k]()
                v.is_external = !!v.is_external //convert to boolean
                state.data = v

                // if(state.data.is_external)
                this.contactData['base'] = state
                break
              case 'notes':
                state = Edit_meta.blank_states[k]()
                state.data = v
                this.contactData['notes'] = state
                break
              case 'groups':
                if (v.length > 0) {
                  let ref
                  let res = []
                  var primary = 0

                  v.forEach(function (item) {
                    let type_id = Number(item.type_id) // !important
                    let items = undefined

                    if (type_id > 0 && window.groups_index.types[type_id]) {
                      items = typeahead.get_display(
                        window.groups_index.types[type_id],
                        window.groups_index
                      )
                    }

                    state = Edit_meta.blank_states[k](items)
                    state.data = item
                    state.type_id = type_id

                    if (item.value > 0) {
                      let group_id = item.value.toString()
                      let ref = window.groups_index.ref[item.value]
                      if (!ref) {
                        console.log('Error: group not found ' + item.value)
                      }
                      else {
                        state.display = window.groups_index.list[ref].n
                        res.push(state)
                      }
                    }

                    if(Number(item.is_primary) === 1) {
                      primary = state.data.rel_id
                    }
                  })

                  vm.primary[k] = primary
                  this.contactData[k] = res
                }
                break
              case 'organizations':
                if (v.length > 0) {
                  let ref
                  let res = []
                  var primary = 0

                  v.forEach(function (item) {
                    let type_id = Number(item.type_id) // !important
                    let items = undefined

                    if (type_id > 0 && window.groups_index.types[type_id]) {
                      items = typeahead.get_display(
                        window.orgs_index.types[type_id],
                        window.orgs_index
                      )
                    }

                    state = Edit_meta.blank_states[k](items)
                    state.data = item
                    state.type_id = Number(item.type_id) // !important
                    // state.type_id = item.type_id.toString() // !important
                    let org_id = Number(item.value) // !important

                    if (org_id > 0) {
                      ref = window.orgs_index.ref[org_id]

                      // console.log()

                      if (!ref) {
                        console.log('Error: organization not found ' + org_id, window.orgs_index.ref)
                      }
                      else {
                        state.display = window.orgs_index.list[ref].n
                        res.push(state)
                      }
                    }

                    if(Number(item.is_primary) === 1){
                      primary = state.data.rel_id
                    }
                  })

                  vm.primary[k] = primary
                  this.contactData[k] = res
                }
                break
              default:
                if (v.length > 0) {
                  let res = []
                  var primary = 0
                  v.forEach(function (item) {
                    state = Edit_meta.blank_states[k]()
                    state.data = item
                    if(Number(item.is_primary) === 1) {
                      // console.log('k', k, item.is_primary)
                      primary = state.data.rel_id
                    }
                    res.push(state)
                  })

                  vm.primary[k] = primary

                  this.contactData[k] = res
                }
                break
            }
          }
          // console.log('final primary', JSON.stringify(vm.primary))
        }, (response) => {
          // error callback
        })
    }
    else {
      let v
      let type = this.$store.state.type
      this.contactData.base.data.type = (type === 'contact') ? 1 : 2

      for (let k in this.contactData) {
        switch (k) {
          case 'base':
            break
          case 'notes':
            this.contactData[k] = Edit_meta.blank_states[k]()
            break
          default:
            this.contactData[k] = [Edit_meta.blank_states[k]()]
            break
        }
      }
    }

  }
}
</script>
<style>
.item-icon .btn {
  display: block;
  /*height: 100%;*/
  margin: 5px;
  text-align: center;
}

.list.form > .item {
  clear: both;
}

.bookmark-tag-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px 20px;
  color: #ccc;
  cursor: pointer;
  z-index: 10;
}

.bookmark-tag-btn.active {
  color: #34495E;
}

.contact-edit .item-icon .v-radio-input {
  float: left;
  vertical-align: 10px;
  height: 100%;
  line-height: 100%;
}

.contact-edit .item-icon .v-radio {
  padding-top: 25px;
}

.contact-edit .item-icon .del-btn {
  float: right;
}

.contact-edit .item-icon .del-btn i {
  padding-top: 1.25rem;
  line-height: 1.3rem;
  width: 30px;
}

.contact-edit .list.form .column {
  padding-right: 0;
}

.contact-edit .is_external_checkbox .v-label {
  padding-left: 2rem;
}

</style>
